<template>
    <div class="h-full w-full bg-light text-white flex flex-col items-center justify-center">
        
        <h1 data-aos="fade-up" class="font-montserrat text-3xl text-center uppercase px-10 font-bold" v-html="$t('welcome')"></h1>
        <i data-aos="fade-down" data-aos-delay="300" class="fas fa-gamepad text-6xl mt-2"></i>

        <p class="px-10 text-center font-montserrat my-5">{{ $t('desc') }}</p>

        <nav data-aos="zoom-in" data-aos-delay="600" class="w-9/12 mt-10 z-10">
            <button @click="start" class="rounded-full text-xl w-full shadow-2xl p-4 bg-black">{{ $t('start') }}</button>
        </nav>

        <img data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" class="circle-top h-72" src="../../assets/images/circle@2x.png" alt="">
        <img class="triangle-top filter-white h-48" src="../../assets/images/triangle@2x.png" alt="">
        
        <img data-aos="fade-up" data-aos-delay="500" data-aos-duration="500" class="circle-bottom h-72" src="../../assets/images/circle@2x.png" alt="">
        <img class="triangle-bottom filter-white h-64" src="../../assets/images/triangle-b@2x.png" alt="">

    </div>
</template>

<script>
export default {
	i18n: {
		messages: {
			en: { 
				welcome: 'Welcome to the <span class="text-primary text-2xl">GAME</span>',
				desc: 'Consumers love to engage with brands through gamification!',
                start: "Let's Play"
			},
			de: { 
				welcome: 'Willkommen zum <span class="text-primary text-2xl">Spiel</span>',
				desc: 'Verbraucher lieben es, sich durch Gamification mit Marken zu beschäftigen!',
                start: "Los geht's"
			},
			ru: { 
				welcome: 'Доброе пожаловать в <span class="text-primary text-2xl">игру</span>',
				desc: 'Потребителям нравится взаимодействовать с брендами при помощи геймификации.',
                start: "Играть"
			}
		}
	},
    methods: {
        start(){
            this.$emit('upcomponent', 'game.play')
        }
    },
    mounted(){
        this.$plausible.trackPageview({
            url: "https://connectedpackage.digital/game/intro"
        })
    }
}
</script>

<style>

</style>